import * as recipeHandlers from 'components/desktop/Recipe/RecipeComponentHandlers';
import { IProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/Index';
import NutritionFactsLabelWrapper from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/NutritionFactsLabelWrapper';
import ValueScopeButtons from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/ValueScopeButtons';
import Co2Display from 'components/desktop/_general/Co2Display/Co2Display';
import NutriScoreDiagram from 'components/desktop/_general/NutriScoreDiagram/NutriScoreDiagram';
import NutritionDiagram from 'components/desktop/_general/NutritionDiagram/NutritionDiagram';
import PriceDisplay from 'components/desktop/_general/PriceDisplay';
import { ValueScopeInfo } from 'functions/valueScopeConversion';
import useCurrency from 'hooks/redux/useCurrency';
import { useReaction } from 'hooks/useReaction';
import * as Calculation from 'types/Recipe/Calculation';
import { IncorporationShare } from 'types/Recipe/Recipe';

export type IncorporationShareWithIndex = IncorporationShare & { index: number };

const Sidebar = (props: IProps & { calculation: Calculation.Type }) => {
	const currency = useCurrency();

	const [nutriScore] = useReaction(
		null,
		async (_signal: number) => {
			if (!props.recipe.hasNutriScore) return null;
			return await recipeHandlers.getNutriScore(props.segments);
		},
		props.state.recalculationSignal
	);

	const recipeCalculation = props.calculation;
	const nutrients = recipeCalculation?.nutrientValues ?? [];

	const getMacroNutrientChartData = (): { label: string; value: number }[] => {
		if (!recipeCalculation || !nutrients) return [];
		const macroWeight = nutrients
			.filter((n) => n.isMacroNutrient)
			.reduce((p, c) => p + c.total, 0);
		const macros = nutrients
			.filter((n) => n.isMacroNutrient)
			.map((n) => {
				return { label: n.nutrient, value: n.total / macroWeight };
			});
		return macros;
	};

	const valueScopeInfo: ValueScopeInfo = {
		valueScope: props.state.valueScope,
		persons: props.recipe.persons,
		parts: props.recipe.parts,
		weight: recipeCalculation?.weight ?? props.recipe.weight ?? props.recipe.ingredientWeight,
	};

	return (
		<>
			<fieldset style={{ marginBottom: '20px' }}>
				<NutritionFactsLabelWrapper calculation={props.calculation} recipe={props.recipe} />
			</fieldset>
			<fieldset className="d-flex flex-column" style={{ gap: '15px' }}>
				<div
					style={{
						borderBottom: '1px solid #ccc',
						borderTop: '1px solid #ccc',
						padding: '5px 0px',
					}}
				>
					<ValueScopeButtons
						valueScope={props.state.valueScope}
						setValueScope={props.handlers.setValueScope}
					/>
				</div>
				<Co2Display
					value={recipeCalculation?.carbonDioxideValue ?? props.recipe.carbonDioxideValue}
					color={
						recipeCalculation?.carbonDioxideLabel?.color ??
						props.recipe.carbonDioxideLabel?.color ??
						'#000'
					}
					valueScopeInfo={valueScopeInfo}
				/>
				<PriceDisplay
					value={props.calculation?.price ?? 0}
					currency={currency}
					valueScopeInfo={valueScopeInfo}
				/>
				<NutriScoreDiagram nutriScore={nutriScore ?? props.recipe.nutriScore ?? null} />
				<div style={{ marginTop: '20px' }}>
					<NutritionDiagram data={getMacroNutrientChartData()} />
				</div>
			</fieldset>
		</>
	);
};

export default Sidebar;
